export enum DynamicForm {
    Triage = 'Triage',
    MedicationError = 'MedicationError',
}
